import React from 'react'

const SvgBackpackFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M5.358 2.09L3.224 3.594a.548.548 0 00-.209.573l.906 3.832a9.55 9.55 0 012.837-2.923l-.632-2.672c-.084-.357-.478-.519-.768-.314zM17.242 5.076A9.551 9.551 0 0120.08 8l.906-3.832a.548.548 0 00-.21-.573L18.643 2.09c-.29-.205-.683-.043-.768.314l-.632 2.672z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.933 2A2.933 2.933 0 008 4.933V6.07A7.997 7.997 0 004 13v7.74c0 .696.564 1.26 1.26 1.26h13.48A1.26 1.26 0 0020 20.74V13a7.997 7.997 0 00-4-6.93V4.933A2.933 2.933 0 0013.067 2h-2.134zM14.4 5.366v-.433c0-.736-.597-1.333-1.333-1.333h-2.134c-.736 0-1.333.597-1.333 1.333v.433A7.996 7.996 0 0112 5c.836 0 1.642.128 2.4.366zM12 9.836c-1.114 0-2.147.899-2.25 2.008a.75.75 0 01-1.494-.14c.179-1.92 1.898-3.369 3.744-3.369 1.867 0 3.492 1.449 3.74 3.342a.75.75 0 11-1.487.195C14.1 10.704 13.093 9.835 12 9.835zm-3.94 6.196a1 1 0 011-1h5.88a1 1 0 011 1v1.704a1 1 0 01-1 1H9.06a1 1 0 01-1-1v-1.704z'
    />
  </svg>
)

export default SvgBackpackFilled
